function pad(num) {
  return num < 10 ? '0' + num : '' + num;
}

export function formatDate(date) {
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
}

export function todayStr() {
  return formatDate(new Date());
}

export function monthStartStr() {
  const date = new Date();
  date.setDate(1);
  return formatDate(date);
}

export function daysAgoStr(days) {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return formatDate(date);
}

export function currentMonth() {
  const date = new Date();
  return date.getFullYear() + '-' + pad(date.getMonth() + 1);
}

export function defaultDateRange() {
  return [monthStartStr(), todayStr()];
}

export function isDateRangeOverDays(startDate, endDate, maxDays) {
  if (!startDate || !endDate) return false;
  const start = new Date(startDate + 'T00:00:00');
  const end = new Date(endDate + 'T00:00:00');
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;
  const diffDays = Math.floor((end.getTime() - start.getTime()) / 86400000);
  return diffDays < 0 || diffDays > maxDays;
}



// WEBPACK FOOTER //
// ./src/utils/date.js